import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import ErrorToast from '@/components/toasts/ErrorToast';
import { responseError } from '@/utils/errors';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import actions from '../constants';

export function* updateDatasetNamespaceErrorToast(action) {
  yield call(
    showToast,
    <ErrorToast operation="actions.update" name={action.name} error={responseError(action).message} />,
  );
}

export function* updateDatasetNamespacesToast({ code, name }) {
  yield call(showToast, <UpdatedToast code={code} name={name} />);
}

export default function* datasetNamespacesToasts() {
  yield takeEvery(
    [actions.ADD_DATASET_NAMESPACE_SUCCESS, actions.REMOVE_DATASET_NAMESPACE_SUCCESS],
    updateDatasetNamespacesToast,
  );
  yield takeEvery(actions.UPDATE_DATASET_NAMESPACES_ERROR, updateDatasetNamespaceErrorToast);
}
